import { FC } from "react";
import { TrailerCloseoutModal } from "./TrailerCloseoutModal";
import { TrailerConfirmationModal } from "./TrailerConfirmationModal";
import { TrailerTypeSelectionModal } from "./TrailerTypeSelectionModal";
import { TrailerCloseoutErrorModal } from "./TrailerCloseoutErrorModal";

export const trailerCloseoutModalMap: Record<TrailerCloseoutModal, FC<any>> = {
  [TrailerCloseoutModal.INVALID_BOL_ID]: TrailerCloseoutErrorModal,
  [TrailerCloseoutModal.BOL_NOT_FOUND]: TrailerCloseoutErrorModal,
  [TrailerCloseoutModal.INVALID_BOL]: TrailerCloseoutErrorModal,
  [TrailerCloseoutModal.TRAILER_CONFIRMATION]: TrailerConfirmationModal,
  [TrailerCloseoutModal.TRAILER_TYPE_SELECTION]: TrailerTypeSelectionModal,
  [TrailerCloseoutModal.UNKNOWN_ERROR]: TrailerCloseoutErrorModal,
};
